import {isBefore} from 'date-fns';

import {TaskResponseBody} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {IconColors} from '../constants/activityItem';

export const transformTaskToActivity = (task: TaskResponseBody) => {
  const taskTimestamp = task.dueTo ?? task.dueDate ?? task.createdAt ?? new Date().toISOString();
  const isFinished = task?.finishedAt !== null;
  const taskDueDate = task?.dueTo ?? task?.dueDate;
  const isOverdue = taskDueDate && isBefore(parseDate(taskDueDate), new Date());

  return {
    id: task.id,
    userId: task.createdBy,
    reasonCloseCodeId: null,
    reasonCloseNote: null,
    interestId: null,
    description: task.title,
    activityType: 'TASK_CREATED' as const,
    timestamp: taskTimestamp,
    color: !isFinished && isOverdue ? IconColors.RED : IconColors.GREEN,
    userName: '',
    relatedTask: task,
    relatedMessage: null,
    relatedCall: null,
    isEditable: true,
    subject: null,
    interestCode: null,
    interestType: null,
    businessCaseId: null,
    businessCaseCode: null,
    businessCaseType: null,
    relatedChatConversation: null,
    relatedTestDrive: null,
  };
};
